import { format } from 'date-fns'

export default function flattenProfileInfo (
  obj: Record<string, string | boolean | null | undefined>,
  parentKey = '',
): { fieldName: string; value: string | boolean }[] {
  return Object.entries(obj).flatMap(([ key, value ]) => {
    const fullKey = parentKey ? `${parentKey}.${key}` : key

    if ((value as unknown) instanceof Date) {
      return [
        { fieldName: fullKey, value: format(value as string | number | Date, 'yyyy-MM-dd') },
      ]
    }

    if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
      return flattenProfileInfo(value, fullKey)
    }

    return [ { fieldName: fullKey, value: value! } ]
  })
}
